import React from "react";
import { useHotel } from "../contexts/HotelContext";
import { useImpersonation } from "../hooks/useImpersonation";

/**
 * Banner displayed when admin is impersonating another user.
 * Shows the impersonated user's email and a button to stop impersonation.
 */
export const ImpersonationBanner: React.FC = () => {
  const { user, isImpersonating } = useHotel();
  const { stopImpersonation, isStopping } = useImpersonation();

  if (!isImpersonating || !user) {
    return null;
  }

  return (
    <div
      className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between"
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <span className="font-medium">
          Zalogowano jako: {user.email}
        </span>
        <span className="text-amber-100 text-sm">
          ({user.firstName} {user.lastName})
        </span>
      </div>
      <button
        onClick={stopImpersonation}
        disabled={isStopping}
        className="bg-white text-amber-600 px-3 py-1 rounded-md text-sm font-medium hover:bg-amber-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        aria-label="Zakończ impersonację i wróć do konta administratora"
      >
        {isStopping ? "Kończenie..." : "Zakończ impersonację"}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
